import { Typography } from "@mui/material";
import { Map } from "ol";
import React from "react";
import { useDateFormatter } from "~/utils/hooks/useDateFormatter";
import { EquipmentDetailsMapItem } from "../types/mapItems";
import { GenericPopup } from "./GenericPopup";

type Props = {
  map: Map;
} & (ClickProps | HoverProps);

type ClickProps = {
  clickData: EquipmentDetailsMapItem;
  hoverData?: EquipmentDetailsMapItem;
};

type HoverProps = {
  hoverData: EquipmentDetailsMapItem;
  clickData?: EquipmentDetailsMapItem;
};

export const VehicleEquipmentPopup = ({
  hoverData,
  clickData,
  map,
}: Props): JSX.Element | null => {
  const dateFormatter = useDateFormatter();

  const data = clickData ?? hoverData;

  if (!data || !data.tracker) return null;

  const { name, tracker, equipmentType } = data;

  return (
    <GenericPopup
      map={map}
      clicked={!!clickData}
      avatarText={name[0]}
      title={name}
      subheader={dateFormatter({ date: tracker?.locationTimestamp })}
      contentProps={{ sx: { paddingY: "6px !important" } }}
      content={
        <Typography sx={{ margin: 0 }}>{equipmentType?.name}</Typography>
      }
    />
  );
};
